import cn from 'classnames';
import { Typography, Avatar, makeStyles } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import typography from 'seagull/foundations/typography.module.scss';
import styles from "./MemberIdentifyingUnit.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStyles = makeStyles(() => ({
  styledAvatar: {
    backgroundColor: colors.purple300,
    fontFamily: typography.fontFamilyNormal,
    fontSize: typography.fontSizeP1,
    lineHeight: typography.lineHeightP1
  }
}));
export function MemberIdentifyingUnit(_ref) {
  let {
    user,
    testId
  } = _ref;
  const userInitials = user.initials();
  const moreStyles = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsx(Avatar, {
      className: cn(styles.avatar, moreStyles.styledAvatar),
      children: userInitials
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.details,
      children: [/*#__PURE__*/_jsx(Typography, {
        testId: "".concat(testId, "-full-name"),
        children: user.fullName()
      }), /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        testId: "".concat(testId, "-email"),
        ellipsis: true,
        children: user.email()
      })]
    })]
  });
}